export { EventBus } from './eventBus';
export type { EventHandler, Unsubscribe } from './eventBus';

export * from './eventFactory/event';
export * from './eventFactory/eventTypes';
export { EventFactory } from './eventFactory/eventFactory';

export { PostMessageAdapter } from './adapters/postMessageAdapter';
export { CallbackAdapter } from './adapters/callbackAdapter';
export type { EventBusAdapter } from './adapters/eventBusAdapter';
export type { EventCallback, CallbackMap } from './adapters/callbackAdapter';

import { EventBus } from './eventBus';
import { EventBusInitOptions, EventBusManager } from './eventBustManager';

let defaultEventBus: EventBus | null = null;

export function initEventBus(options: EventBusInitOptions): EventBus {
  if (!options.adapters || !Array.isArray(options.adapters)) {
    throw new Error(
      '[EventBus] Adapters must be explicitly provided as an array of instances. Example: adapters: [PostMessageAdapter.factory()]'
    );
  }

  const enableLogging = options.enableLogging ?? false;

  const manager = EventBusManager.initialize({
    enableLogging,
    adapters: options.adapters,
  });

  defaultEventBus = manager.getEventBus();

  return defaultEventBus;
}

export const eventBus = new Proxy<EventBus>(
  {} as EventBus,
  {
    get: (target, prop) => {
      if (!defaultEventBus) {
        console.error(
          '[EventBus] Not initialized. Call initEventBus() in bootstrap.tsx first'
        );
        throw new Error('[EventBus] Not initialized');
      }
      return (defaultEventBus as any)[prop];
    },
  }
);
